import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'td-wb-ticker-symbol-table-container',
  template: '<ng-content />',
  styleUrls: ['ticker-symbol-table-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TickerSymbolTableContainerComponent {
}
